//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export abstract class CustomProblemDetailsTypes
{
	public static StructureCreatorUpdateFailure: string = `3962b9e8-5cb8-4b7b-9c7d-0610d61f365f`;
}
export interface IAdConnectionDto
{
	connectionData: IActiveDirectoryConnectionInfoHolder;
	organizationalUnitName: string;
}
export interface IConfigurationDto
{
	id: string;
	legacyId: number;
	tenantId: string;
	name: string;
	description: string;
	status: ServiceStatus;
	queues: IQueueStatus;
	hasIssues?: boolean;
	groupStorage: GroupStorage;
	sscEnabled: boolean;
	highAvailabilityMode: HighAvailabilityModes;
}
export interface IConfigurationCreateOrUpdateDto
{
	id: string;
	name: string;
	description: string;
}
export interface IExplicitFolderPermissionsDto
{
	privileges: ISharePointPrivilegeLevel[];
	principals: ISharePointPrincipalCollection;
	entities: IEntityInfo[];
	users: ICRMPrincipalHolder[];
	teams: ICRMPrincipalHolder[];
}
export interface ILogHistoryDto
{
	logs: ILogHolder[];
	metadata: ILogSetDataHolder;
}
export interface IScriptDto
{
	script: string;
	isRealData: boolean;
	input: ILuaScriptInput;
	functionName: string;
}
export interface IServiceStatusConfigurationUpdateDto
{
	settings: ISettings;
	libraryDistribution: ILibraryDistribution;
	siteDistribution: ISiteDistribution;
	siteCollectionDistribution: ISiteCollectionDistribution;
}
export interface IAuthCodeFlowModernAuthenticationDto
{
	aadInstance: string;
	tenantId: string;
	clientId: string;
	clientSecret: string;
	tokenResponse: string;
	scope: string;
}
export enum ExportFormat {
	Csv = 0,
	Json = 1,
	Xml = 2
}
export interface IPageDto<T>
{
	totalNumberOfItems: number;
	page: number;
	pageSize: number;
	items: T[];
}
export interface IEntityReference
{
	id: string;
	logicalName: string;
	name: string;
}
export interface ICascadeConfiguration
{
	assign?: CascadeType;
	delete?: CascadeType;
	merge?: CascadeType;
	reparent?: CascadeType;
	share?: CascadeType;
	unshare?: CascadeType;
	rollupView?: CascadeType;
}
export enum CascadeType {
	NoCascade = 0,
	Cascade = 1,
	Active = 2,
	UserOwned = 3,
	RemoveLink = 4,
	Restrict = 5
}

export const CascadeTypeName = new Map<number, string>([
[CascadeType.NoCascade,'NoCascade'],
[CascadeType.Cascade,'Cascade'],
[CascadeType.Active,'Active'],
[CascadeType.UserOwned,'UserOwned'],
[CascadeType.RemoveLink,'RemoveLink'],
[CascadeType.Restrict,'Restrict']]);

export interface IDirectoryGroup extends ISharePointDirectoryPrincipal
{
}
export interface IDynamics365Event extends ICRMEventBase
{
	messageCode: Messages;
	primaryObjectID: string;
	primaryObjectTypeCode: string;
	secondaryObjectID: string;
	secondaryObjectTypeCode: string;
	data: string;
	createdOn: Date;
}
export interface ICRMEventBase
{
	id: string;
	timestamp: Date;
}
export interface IMessageHolder
{
	value: Messages;
	label: string;
}
export interface IRoleToPrincipal
{
	roles: number[];
	roleNames: string[];
	principal: IPrincipal;
	isExplicit: boolean;
}
export interface IPrincipal
{
	id: number;
	isUser: boolean;
	directoryLogin: string;
}
export interface IRoleToPrincipalIncremental
{
	toAdd: IRoleToPrincipal[];
	toRemove: IRoleToPrincipal[];
}
export interface ISecurityPrincipal
{
	crM_ID: string;
	sharePointIDs: { [key:number]: ISharePointLoginInfo[] };
	directoryIDs: IDirectoryLoginInfo[];
	name: string;
}
export interface ISharePointDirectoryPrincipal extends ISharePointPrincipal
{
}
export interface ISharePointGroup extends ISharePointPrincipal
{
}
export interface ILoginInfo
{
	loginName: string;
	name: string;
	isCustomMapping: boolean;
}
export interface ISharePointLoginInfo extends ILoginInfo
{
	id: number;
	isDeleted: boolean;
}
export interface IDirectoryLoginInfo extends ILoginInfo
{
}
export interface ISharePointPrincipal
{
	id: number;
	name: string;
	email: string;
	loginName: string;
}
export interface ISharePointPrincipalCollectionBase
{
	users: ISharePointUser[];
	sharePointGroups: ISharePointGroup[];
	directoryGroups: IDirectoryGroup[];
}
export interface ISharePointPrincipalCollection extends ISharePointPrincipalCollectionBase
{
}
export interface ISharePointPrivilegeLevel
{
	id: number;
	name: string;
	customPrivileges: string;
	default_CRM_AccessRight?: AccessRights;
}
export interface ISharePointUser extends ISharePointDirectoryPrincipal
{
}
export interface IUser extends ISecurityPrincipal
{
	email: string;
	loginName: string;
	isDisabled: boolean;
	isLicensed?: boolean;
	sharePointBlockedIDs: { [key:number]: ISharePointLoginInfo[] };
}
export enum Messages {
	CreateTeam = 101,
	UpdateTeam = 102,
	DeleteTeam = 103,
	AddTeamMember = 111,
	RemoveTeamMember = 112,
	AddTeamRole = 121,
	RemoveTeamRole = 122,
	AddTeamTemplateMember = 131,
	RemoveTeamTemplateMember = 132,
	CreateUser = 201,
	UpdateUser = 202,
	DisableUser = 203,
	DisableUserInTargetSystem = 204,
	AddUserRole = 221,
	RemoveUserRole = 222,
	UpdateUserPosition = 231,
	UpdateUserManager = 232,
	CreateRole = 301,
	UpdateRole = 302,
	DeleteRole = 303,
	CreateBusinessUnit = 401,
	UpdateBusinessUnit = 402,
	DeleteBusinessUnit = 403,
	DisableBusinessUnit = 404,
	CreateSharepointDocumentLocation = 501,
	UpdateSharepointDocumentLocation = 502,
	DeleteSharepointDocumentLocation = 503,
	CreateHierarchySecurityConfiguration = 601,
	UpdateHierarchySecurityConfiguration = 602,
	DeleteHierarchySecurityConfiguration = 603,
	CreatePosition = 701,
	UpdatePosition = 702,
	DeletePosition = 703,
	ShareAccess = 1001,
	ModifyAccess = 1002,
	RevokeAccess = 1003,
	ChangeBusinessUnit = 2001,
	ChangeRecordOwner = 2002,
	UpdateHierarchySecuritySettings = 2003,
	ReparentRecord = 2004,
	ChangeStateCode = 2005,
	ChangeRecordOwningBusinessUnit = 2006,
	ChangeRemappedRegardingObject = 2007,
	ForceFullIteration = 9001,
	OverwritePermissions = 9002
}

export const MessagesName = new Map<number, string>([
[Messages.CreateTeam,'Create team'],
[Messages.UpdateTeam,'Update team'],
[Messages.DeleteTeam,'Delete team'],
[Messages.AddTeamMember,'Add team member'],
[Messages.RemoveTeamMember,'Remove team member'],
[Messages.AddTeamRole,'Add security role to team'],
[Messages.RemoveTeamRole,'Remove security role from team'],
[Messages.AddTeamTemplateMember,'Add access team template member'],
[Messages.RemoveTeamTemplateMember,'Remove access team template member'],
[Messages.CreateUser,'Create user'],
[Messages.UpdateUser,'Update user'],
[Messages.DisableUser,'Disable user'],
[Messages.DisableUserInTargetSystem,'Disable user in target system'],
[Messages.AddUserRole,'Add security role to user'],
[Messages.RemoveUserRole,'Remove security role from user'],
[Messages.UpdateUserPosition,'Update user position'],
[Messages.UpdateUserManager,'Update user manager'],
[Messages.CreateRole,'Create security role'],
[Messages.UpdateRole,'Update security role'],
[Messages.DeleteRole,'Delete security role'],
[Messages.CreateBusinessUnit,'Create business unit'],
[Messages.UpdateBusinessUnit,'Update business unit'],
[Messages.DeleteBusinessUnit,'Delete business unit'],
[Messages.DisableBusinessUnit,'Disable business unit'],
[Messages.CreateSharepointDocumentLocation,'Create SharePoint document location'],
[Messages.UpdateSharepointDocumentLocation,'Update SharePoint document location'],
[Messages.DeleteSharepointDocumentLocation,'Delete SharePoint document location'],
[Messages.CreateHierarchySecurityConfiguration,'Create hierarchy security configuration'],
[Messages.UpdateHierarchySecurityConfiguration,'Update hierarchy security configuration'],
[Messages.DeleteHierarchySecurityConfiguration,'Delete hierarchy security configuration'],
[Messages.CreatePosition,'Create position'],
[Messages.UpdatePosition,'Update position'],
[Messages.DeletePosition,'Delete position'],
[Messages.ShareAccess,'Share record'],
[Messages.ModifyAccess,'Modify sharing'],
[Messages.RevokeAccess,'Stop sharing'],
[Messages.ChangeBusinessUnit,'Change business unit'],
[Messages.ChangeRecordOwner,'Assign record'],
[Messages.UpdateHierarchySecuritySettings,'Update hierarchy security settings'],
[Messages.ReparentRecord,'Reparent record'],
[Messages.ChangeStateCode,'Change status'],
[Messages.ChangeRecordOwningBusinessUnit,'Assign record (business unit)'],
[Messages.ChangeRemappedRegardingObject,'Change root object'],
[Messages.ForceFullIteration,'Force full iteration'],
[Messages.OverwritePermissions,'Overwrite permissions']]);

export interface ISPGroup
{
	id?: number;
	name: string;
	description: string;
	kind: SPGroupKind;
	members: number[];
	toAddMembers: number[];
	toRemoveMembers: number[];
}
export enum SPGroupKind {
	New = 0,
	UpdateMembers = 10,
	UpdateMembersIncremental = 20,
	Ensure = 30,
	DeleteWithExistenceCheck = 50
}

export const SPGroupKindName = new Map<number, string>([
[SPGroupKind.New,'New'],
[SPGroupKind.UpdateMembers,'UpdateMembers'],
[SPGroupKind.UpdateMembersIncremental,'UpdateMembersIncremental'],
[SPGroupKind.Ensure,'Ensure'],
[SPGroupKind.DeleteWithExistenceCheck,'DeleteWithExistenceCheck']]);

export interface IRuntimeInfo
{
}
export interface IUserMappingSummary
{
	recordCount: number;
	totalMappedUser: number;
	availableUserLicenses?: number;
	hasValidSubscription: boolean;
	totalLicensedUsersCount: number;
	mode: MappingMode;
}
export interface IBoardInfo
{
	errors: number;
	warnings: number;
	resetDate: Date;
	id: string;
	status: ServiceStatus;
	lastStart?: Date;
	lastStop?: Date;
	lastFullIterationStart?: Date;
	lastConfigurationChanged?: Date;
	configurationChangedWhileRunning: boolean;
}
export interface IConfiguration
{
	instanceId: string;
	securityTenantId: string;
	name: string;
	description: string;
	status: ServiceStatus;
	boardInfo: IBoardInfo;
	groupStorage: GroupStorage;
	sscEnabled: boolean;
	highAvailabilityMode: HighAvailabilityModes;
}
export interface ICRMPrincipalHolder
{
	id: string;
	name: string;
}
export interface IEntityInfo
{
	logicalName: string;
	displayName: string;
	isActivity: boolean;
}
export interface IEventRecord
{
	eventId: string;
	timestamp: Date;
	eventName: Messages;
}
export interface IPermissionPreview
{
	currentMapping: { [key in AccessRights]: IPermissionMappingItem[] };
	existingPrivilegesLevels: ISharePointPrivilegeLevel[];
}
export interface IQueueStatus
{
	eventQueue?: number;
	calculateQueue?: number;
	writerQueue?: number;
}
export interface IReplicatorScheduleDowntime
{
	title: string;
	message: string;
	scheduledDate: Date;
}
export interface IResult
{
	success: boolean;
	error: string;
	hintText: string;
	warning: string;
}
export interface IResultOfType<T> extends IResult
{
	data: T;
}
export interface ISecurityRoleInfo
{
	name: string;
}
export interface ISharePointLocationHolder
{
	url: string;
	crmEntityName: string;
	crmEntityId: string;
	documentLocationId: string;
	lastModifiedOn?: Date;
}
export interface ISharePointLocationList
{
	sharePointLocations: ISharePointLocationHolder[];
	total: number;
}
export enum ServiceStatus {
	Started = 0,
	Starting = 1,
	InitialLoading = 2,
	BackupStandBy = 3,
	Stopped = 4,
	Stopping = 5,
	Creating = 6
}

export const ServiceStatusName = new Map<number, string>([
[ServiceStatus.Started,'Started'],
[ServiceStatus.Starting,'Starting'],
[ServiceStatus.InitialLoading,'Initial loading'],
[ServiceStatus.BackupStandBy,'Backup standby'],
[ServiceStatus.Stopped,'Stopped'],
[ServiceStatus.Stopping,'Stopping'],
[ServiceStatus.Creating,'Creating']]);

export interface IDirectoryUserMappingExportItem extends IUserMappingExportItem
{
	directoryLogin: string;
	directoryTitle: string;
}
export interface ISharePointUserMappingExportItem extends IUserMappingExportItem
{
	sharePointId?: number;
	sharePointLogin: string;
	sharePointTitle: string;
}
export interface IUserMappingExportItem
{
	status: UserMappingStatus;
	custom: boolean;
	dynamics365Id: string;
	dynamics365LoginName: string;
	dynamics365Name: string;
	dynamics365Email: string;
}
export interface ILogHolder
{
	actionType: ActionType;
	timeStamp: Date;
	message: string;
	additionalText: string;
}
export interface ILogRecord
{
	timestamp: Date;
	location: string;
	permissionSet: string;
}
export interface ILogSetDataHolder
{
	recordCount: number;
	hasMoreRecords: boolean;
}
export enum ActionType {
	DEBUG = 1,
	INFO = 2,
	WARN = 3,
	EVENT = 4,
	ERROR = 5,
	PERMISSION_WRITE = 6
}

export const ActionTypeName = new Map<number, string>([
[ActionType.DEBUG,'DEBUG'],
[ActionType.INFO,'INFO'],
[ActionType.WARN,'WARN'],
[ActionType.EVENT,'EVENT'],
[ActionType.ERROR,'ERROR'],
[ActionType.PERMISSION_WRITE,'PERMISSION_WRITE']]);

export enum DataSourceType {
	Database = 1,
	CRM = 2
}

export const DataSourceTypeName = new Map<number, string>([
[DataSourceType.Database,'Database'],
[DataSourceType.CRM,'CRM']]);

export interface IConnectedWriterInfo
{
	clientInfo: IWriterClientInfo;
	connectedOn: Date;
	lastKeepAlive?: Date;
	isLicensed: boolean;
}
export interface IPermissionMessage
{
	url: string;
	fullPermissionBatch: IRoleToPrincipal[];
	incrementalPermissionBatch: IRoleToPrincipalIncremental;
	lastRequestedHash: string;
	isIncremental: boolean;
	cfg_MaxObjectPaths: number;
	cfg_CachedCookieContainerExpiration: string;
	cfg_AllowedObjectTypes: AllowedSharePointObjectTypes;
	cfg_RateLimiterMinimumCapacityLeft: number;
	cfg_RefferToSharePointPermissionLevelsByName: boolean;
	cfg_Timeout: string;
	resetRoleInheritanceAtFirstTimeSecure: ResetRoleInheritanceMode;
	groupStorage: GroupStorage;
	customMappingLevelNamesToPrivileges: { [key:string]: string };
}
export interface IRegisterResponse
{
	code: number;
	message: string;
}
export interface IWriterClientInfo
{
	instanceId: string;
	instanceName: string;
	hostName: string;
	protocolVersion: number;
	keepAliveInterval: string;
}
export interface IWriterMessageBase
{
	configurationId: string;
	messageId: string;
}
export interface IWriterMessage extends IWriterMessageBase
{
	targetSystemData: ISharePointConnectionInfoHolder;
	command: Command;
	commandVersion: number;
	commandData: string;
}
export interface IWriterMessageConfirmation extends IWriterMessageBase
{
	clientInfo: IWriterClientInfo;
	success: boolean;
	executingInstance: string;
	errorMessage: string;
	error: string;
	errorStatus: string;
	errorStatusValue: number;
	arbitraryData: string;
	siteUrl: string;
	missingPrincipals: IPrincipal[];
}
export interface IThrottlingWritterMessage extends IWriterMessageBase
{
	sleepTime: string;
}
export enum Command {
	WRITE_PERMISSIONS = 0
}

export const CommandName = new Map<number, string>([
[Command.WRITE_PERMISSIONS,'WRITE_PERMISSIONS']]);

export interface IAuthenticationHolder
{
	authenticationType: TargetSystemAuthenticationType;
	aadInstance: string;
	tenantId: string;
	clientId: string;
	modernAuthenticationType: S2SAuthenticationType;
	machineCertificate: IMachineCertificate;
}
export interface IMachineCertificate
{
	thumbprint: string;
}
export enum S2SAuthenticationType {
	None = 0,
	DirectCertificate = 1,
	MachineCertificate = 2,
	AzureKeyVaultCertificate = 3,
	ClientSecret = 4,
	ManagedIdentity = 5
}

export const S2SAuthenticationTypeName = new Map<number, string>([
[S2SAuthenticationType.None,'None'],
[S2SAuthenticationType.DirectCertificate,'DirectCertificate'],
[S2SAuthenticationType.MachineCertificate,'MachineCertificate'],
[S2SAuthenticationType.AzureKeyVaultCertificate,'AzureKeyVaultCertificate'],
[S2SAuthenticationType.ClientSecret,'ClientSecret'],
[S2SAuthenticationType.ManagedIdentity,'ManagedIdentity']]);

export interface IConfigurationLicenseInfo
{
	availableConfigurations?: number;
	configurationsInUse?: number;
}
export interface IFeaturesLicenseInfo
{
	highAvailability: boolean;
}
export interface ILoadBalancingLicenseInfo
{
	availableLoadBalancedInstances?: number;
	loadBalancedInstancesInUse?: number;
	writersOverLimitTotal: number;
}
export interface IReplicatorLicenseInfo
{
	isAllowed: boolean;
	isValid: boolean;
	validity?: Date;
	isValidityInherited: boolean;
	users?: number;
	areUsersInherited: boolean;
}
export interface ISharePointStructureCreatorLicenseInfo
{
	isAllowed: boolean;
	isValid: boolean;
	validity?: Date;
	isValidityInherited: boolean;
	users?: number;
	areUsersInherited: boolean;
	features: IFeaturesLicenseInfo;
}
export interface ISummaryLicenseInfo
{
	validity: IValidityLicenseInfo;
	users: IUserLicenseInfo;
	configurations: IConfigurationLicenseInfo;
	loadBalancing: ILoadBalancingLicenseInfo;
	sharePointStructureCreatorLicenseInfo: ISharePointStructureCreatorLicenseInfo;
	replicatorLicenseInfo: IReplicatorLicenseInfo;
	features: IFeaturesLicenseInfo;
}
export interface IUserLicenseInfo
{
	inUseTotal: number;
	inUseCurrentTenant?: number;
	usersOverLimitTotal: number;
	usersOverLimitCurrentTenant: number;
	maximumUsers?: number;
}
export interface IValidityLicenseInfo
{
	validFrom?: Date;
	validTo?: Date;
	isValid: boolean;
}
export interface IActiveDirectoryConnectionInfoHolder extends IConnectionInfoHolderBase
{
}
export interface IAzureActiveDirectoryConnectionInfoHolder extends IConnectionInfoHolderBase
{
	clientId: string;
	administrativeUnitId: string;
}
export interface IConnectionInfoHolderBase
{
	server: string;
	user: string;
	password: string;
	authentication: IAuthenticationHolder;
	accessToken: string;
}
export interface ICRMConnectionInfoHolder extends IOAuthConnectionInfoHolderBase
{
	adfsUrl: string;
}
export interface IHolder
{
	type: HolderType;
	tenant: string;
	clientId: string;
}
export interface IOAuthConnectionInfoHolderBase extends IConnectionInfoHolderBase
{
	clientSecret: string;
	tokenResponse: string;
}
export interface ISharePointConnectionInfoHolder extends IOAuthConnectionInfoHolderBase
{
	adfsBaseUrl: string;
	federationRealmUrn: string;
	apiPermission: string;
}
export enum HolderType {
	ClientSecret = 0,
	UserNameAndPassword = 1
}

export const HolderTypeName = new Map<number, string>([
[HolderType.ClientSecret,'ClientSecret'],
[HolderType.UserNameAndPassword,'UserNameAndPassword']]);

export interface IConfigurationHolder
{
	saaSTenantId: number;
	instanceID: string;
	name: string;
	description: string;
	useCustomCRMConnection: boolean;
	azureAdAuthentication: IAuthenticationHolder;
	azureActiveDirectoryAdministrativeUnitId: string;
	connectionString_CRM: string;
	crM_Authentication: IAuthenticationHolder;
	crM_OrganizationID: string;
	crM_ThrottlingRetryCount: number;
	crM_Timeout: string;
	notificationAddress: string;
	notificationsEnabled: boolean;
	notificationDaysBeforeLicenseExpiry: number;
	directNotifications: boolean;
	directNotificationDelay: number;
	poolNotificationInterval: number;
	notificationEmailProfileName: string;
	notificationEmailMappedUserPercentageLimit: number;
	notificationEmailCumulativeLimit: string;
	notificationEmailEventSubscription: string;
	autoStart: AutoStartMode;
	groupStorage: GroupStorage;
	automaticNavigationAcrossSites: boolean;
	allowLoadDistributedSharePointConnections: boolean;
	activeDirectoryOrganizationalUnitDistinguishedName: string;
	activeDirectoryPrincipalNotAvailableRetryInterval: string;
	activeDirectoryPrincipalNotAvailableMaximumRetryDuration: string;
	autoEventBulkDelete: boolean;
	autoEventBulkDeleteInterval: string;
	lateGroupCreateEnabled: boolean;
	groupCaching: boolean;
	diffPermissionWriteMode: boolean;
	omitEmptyGroups: boolean;
	skipBrokenFolderReferences: boolean;
	replicateAccessTeamTemplateAsGroup: boolean;
	replicateAccessTeamAsGroup: boolean;
	replicateStateCode: boolean;
	filterRelevantAccessTeams: boolean;
	filterRelevantAccessTeamTemplates: boolean;
	addOrderByTeamIdToFetchXmlTeamMembershipQueries: boolean;
	skipDisabledLocations: boolean;
	replicateUserAccessMode: boolean;
	databaseConnectionStringName: string;
	permissionEvaluateWorkers: number;
	permissionWriteWorkers: number;
	permissionWriteMaximumQueueSize: number;
	sharePoint: ISharePointHolder;
	userMapping_AutoRefresh: boolean;
	userMapping_RefreshInterval: number;
	logHistoryEnabled: boolean;
	crmLogHistoryEnabled: boolean;
	entityConfiguration: IEntityConfigurationHolder;
	roleFilterConfiguration: ISecurityRoleFilterConfigurationHolder;
	eventPriorityConfiguration: IEventPriorityHolder[];
	extendedConfiguration: IExtendedConfigurationHolder;
	highAvailabilityMode: HighAvailabilityModes;
	crmHeartbeatInterval: number;
	automaticSharePointUserCreation: AutomaticSharePointUserCreationMode;
	automaticSharePointUserCreationFilterColumns: string;
	automaticSharePointUserCreationFilterExpression: string;
	multipleLinkResolutionType: MultipleLinkResolutionType;
	reportFailingEventChecksAsErrorAfter: string;
	backgroundPermissionsVerification: boolean;
	includeOneNoteDocumentLocations: boolean;
	includeOneDriveDocumentLocations: boolean;
	includeSharedWithMeDocumentLocations: boolean;
	includeMsTeamsDocumentLocations: boolean;
	appendMsTeamsDefaultPermissions: boolean;
	pollingForCreateDocumentLocations: PollingForDocumentLocationMode;
	pollingForRoleChanges: PollingForRoleChangesMode;
	activeDirectoryAttributeForTargetUserPrincipal: string;
	systemUserAttributeForTargetUserPrincipal: string;
	documentLocationFilterField: string;
	documentLocationFilterValue: string;
	documentLocationFilterOperator?: DocumentLocationFilterOperator;
	documentLocationFilterPermissionInheritanceReset: boolean;
	resetRoleInheritanceAtFirstTimeSecure: ResetRoleInheritanceMode;
	skipMinimumRoleEntityRestriction: boolean;
	checkUserRolesAtAzureAd: boolean;
	documentLocationUpdateDepthLevel: number;
	orphanedSharePointDirectoryGroupCleanup: boolean;
	orphanedSharePointGroupCleanup: boolean;
	orphanedDirectoryGroupCleanup: boolean;
	sharePointStructureCreator: ISharePointStructureCreatorConfigurationHolder;
	hasBeenModifiedWhileRunning: boolean;
	modifiedOn: Date;
	sdkMessageProcessingStepsRegistrationMode: SdkMessageProcessingStepsRegistrationMode;
	emailProfilesSaaS: IEmailProfileHolderSaaS[];
}
export interface IDatabaseConnectionHolder
{
	name: string;
	originalName: string;
	provider: string;
	connectionString: string;
	modified: boolean;
}
export interface IDatabaseConnectionHolderWithFields
{
	databaseConnectionHolder: IDatabaseConnectionHolder;
	isSqlServer: boolean;
	sqlLiteFilePath: string;
	serverName: string;
	catalog: string;
	username: string;
	password: string;
	windowsAuthentication: boolean;
	encryptConnection: boolean;
	trustServerCertificate: boolean;
}
export interface IDatabaseTenantUsage
{
	tenantName: string;
	isLocked: boolean;
}
export interface IEmailProfileHolder
{
	name: string;
	recipientEmailAddressText: string;
	fromEmailAddress: string;
	fromEmailDisplayName: string;
	smtpServer: string;
	port: number;
	useSsl: boolean;
	userName: string;
	passwordHash: string;
	password: string;
	isUsedInConfiguration: boolean;
	isCurrentlyInUse: boolean;
	tenantId: number;
	scopes: string;
	azureClientSecret: string;
	azureClientId: string;
	azureTenantId: string;
	jsonKey: string;
	smtpType: SmtpType;
}
export interface IEmailProfileHolderSaaS
{
	name: string;
	emailRecipients: string[];
}
export interface IEntityConfigurationHolder
{
	allEntitiesEnabled: boolean;
	enabledEntities: IEntityHolder[];
}
export interface IEntityHolder
{
	entityName: string;
	isActivity: boolean;
}
export interface IEventPriorityHolder
{
	name: Messages;
	priority: ItemPriority;
}
export interface IExtendedConfigurationHolder
{
	writerType: WriterType;
}
export interface ILoginFormat
{
	type: LoginMatchRule;
	value: string;
	crmDomainFilter: string;
	sharePointDomainFilter: string;
	trimSharePointLogin: boolean;
}
export interface IPermissionMappingHolder
{
	mode: MappingMode;
	refferToSharePointPermissionLevelsByName: boolean;
	permissionPairs: IPermissionPairHolder[];
}
export interface IPermissionMappingItem
{
	isCustom: boolean;
	accessRight: AccessRights;
	privilegeLevel: ISharePointPrivilegeLevel;
	entityName: string;
}
export interface IPermissionPairHolder
{
	crM_AccessRight: AccessRights;
	sharePoint_RoleID?: number;
	sharePoint_PrivilegeLevelName: string;
	sharePoint_CustomPrivileges: string;
	name: string;
	entityName: string;
	isCustomMapping: boolean;
}
export interface IRoleHolder
{
	name: string;
}
export interface ISecurityRoleFilterConfigurationHolder
{
	mode: RoleFilterMode;
	roles: IRoleHolder[];
}
export interface ISharePointAliasHolder
{
	hostName: string;
}
export interface ISharePointGroupHolder
{
	name: string;
	id?: number;
}
export interface ISharePointHolder
{
	sharepointConfig: ISharePointConfigurationItem[];
}
export interface ISharePointConfigurationItem
{
	connectionString: string;
	useCustomConnection: boolean;
	maxObjectPaths: number;
	cachedCookieContainerExpiration: string;
	allowedObjectTypes: AllowedSharePointObjectTypes;
	key: number;
	webId: string;
	name: string;
	isFallback: boolean;
	throttlingRetryCount: number;
	throttlingDelay: string;
	rateLimiterMinimumCapacityLeft: number;
	timeout: string;
	legacySetPermissions: boolean;
	loadDistributedConnectionFor?: number;
	userMapping: IUserMappingHolder;
	permissionMapping: IPermissionMappingHolder;
	authentication: IAuthenticationHolder;
	sharePointAliases: ISharePointAliasHolder[];
	specialPermissions: ISpecialPermissionHolder[];
	userCreationGroups: ISharePointGroupHolder[];
}
export interface ISharePointStructureCreatorConfigurationHolder
{
	enabled: boolean;
	updateInterval: string;
	failoverThresholdInterval: string;
	locationName: string;
	folderNamingRule: FolderNamingRule;
	folderNamingPattern: string;
	libraryDistribution: ILibraryDistribution;
	siteDistribution: ISiteDistribution;
	siteCollectionDistribution: ISiteCollectionDistribution;
	suppressLeadBehavior: boolean;
	suppressOpportunityBehavior: boolean;
	supportOneNote: boolean;
	customScript: string;
	breakRoleInheritance: boolean;
	copyRoleAssignments: boolean;
	subfolderNameSource: SubfolderNameSource;
	skipSubfolder: boolean;
}
export interface ISpecialPermissionHolder
{
	principalType: PrincipalType;
	principalValue: string;
	filterType: FilterType;
	filterValue: string;
	privilegeLevelID: number;
	privilegeLevelName: string;
	customPrivileges: string;
}
export interface IUserMappingHolder
{
	mode: MappingMode;
	userPairs: IUserPair[];
	matchOnlySpecifiedLoginFormats: boolean;
	firstMatchOnly: boolean;
	loginFormats: ILoginFormat[];
	mapUsersAcrossDifferentDomains: boolean;
	crmDomainFilter: string;
	sharePointDomainFilter: string;
}
export interface IUserPair
{
	crM_ID: string;
	sharePoint_ID: number;
	name: string;
	email: string;
	operation: UserMappingOperation;
}
export interface IConnection
{
	url: string;
	user: string;
	password: string;
	account: string;
	extendedProperties: IExtendedProperty[];
	targetServerUrl: string;
	connectionType?: CBConnectionType;
}
export interface IExtendedProperty
{
	name: string;
	value: string;
}
export interface IGetCopyJobProgressLogEntry
{
	event: string;
	errorCode: string;
	message: string;
	migrationDirection: string;
	migrationType: string;
}
export interface ILuaScriptInput
{
	name: string;
	createdOn: Date;
	logicalName: string;
	id: string;
}
export interface ISharePointErrorRoot
{
	error: ISharePointError;
}
export interface ISharePointError
{
	code: string;
	message: ISharePointMessage;
}
export interface ISharePointMessage
{
	lang: string;
	value: string;
}
export interface ISscData
{
	requestedOn?: Date;
	stoppedByWrOn?: Date;
	lastUpdated?: Date;
	lastUpdatedBy: string;
	lastChecked?: Date;
	lastCheckedBy: string;
}
export interface ILicense
{
	validUntil: Date;
}
export interface IServiceStatus
{
	status: ServiceStatusEnum;
	configuration: IConfiguration;
	minimumSharePointVersion: any;
}
export interface IBaseConfiguration
{
	version: number;
}
export interface IConfiguration extends IBaseConfiguration
{
	sharePoints: ISharePoint[];
	licence: string;
	licenseValidUntil: Date;
	settings: ISettings;
	libraryDistribution: ILibraryDistribution;
	siteDistribution: ISiteDistribution;
	siteCollectionDistribution: ISiteCollectionDistribution;
	entityFilter: IEntityFilterCollection;
	crmSystemUserId: string;
	updatedOn?: Date;
	updatedBy: string;
	userCreation: IUserCreation;
	applicationUserIds: string[];
	folderStructureEntity: string;
	sharePointDocumentLocationNameMaxLength?: number;
	sharePointDocumentLocationRelativeUrlMaxLength?: number;
}
export interface IEntityFilter
{
	entityName: string;
	isActivity: boolean;
}
export interface IEntityFilterCollection
{
	entities: IEntityFilter[];
}
export interface ILibraryDistribution
{
	pattern: LibraryRule;
	namePattern: string;
	characterCount?: number;
	unknownCharacter?: string;
	period?: Period;
	periodSource?: PeriodSource;
	libraryTemplate?: number;
	libraryTemplateName: string;
}
export interface IPermissionLevel
{
	id?: number;
	name: string;
}
export interface ISettings
{
	documentLocationName: string;
	folderNamingRule: FolderNamingRule;
	folderNamingPattern: string;
	suppressLeadBehavior: boolean;
	suppressOpportunityBehavior: boolean;
	supportOneNote: boolean;
	breakRoleInheritance: boolean;
	copyRoleAssignments: boolean;
	subfolderNameSource: SubfolderNameSource;
	skipSubfolder: boolean;
	customScript: string;
}
export interface ISharePoint
{
	url: string;
	domain: string;
	user: string;
	password: string;
	encryptedPassword: string;
	adfsBaseUrl: string;
	federationRealmUrn: string;
	isOnline: boolean;
	accessToken: string;
	encryptedAccessToken: string;
	accessTokenExpirationUtcTicks: string;
	encryptedCookie: string;
	cookieExpirationUtcTicks: string;
	key: number;
	sharePointSiteId: string;
	userMapping: IUserMapping;
	targetPermissionLevels: IPermissionLevel[];
	fallbackPermissionLevels: IPermissionLevel[];
	groups: IUserSharePointGroup[];
	maxFolderNameLength?: number;
	rateLimiterOptions: any;
	loadDistributedConnectionFor?: number;
}
export interface ISharePointLogin
{
	id?: number;
	login: string;
}
export interface ISiteCollectionDistribution
{
	pattern: SiteCollectionRule;
	period?: Period;
	periodSource?: PeriodSource;
	namePattern: string;
}
export interface ISiteDistribution
{
	pattern: SiteRule;
	period?: Period;
	periodSource?: PeriodSource;
	namePattern: string;
	characterCount?: number;
	unknownCharacter?: string;
	webTemplate: string;
	language?: number;
}
export interface IUserCreation
{
	isOnDemandSharePointUserCreationAllowed: boolean;
	systemUserAttributeForTargetUserPrincipal: string;
}
export interface IUserMapping
{
	items: { [key:string]: IUserMappingItem };
	isAutomatic: boolean;
}
export interface IUserMappingItem
{
	crmUserId: string;
	logins: ISharePointLogin[];
	canBeCreated: boolean;
}
export interface IUserSharePointGroup
{
	id?: number;
	name: string;
}
export enum ItemPriority {
	Highest = 1,
	AboveNormal = 2,
	Normal = 3,
	BelowNormal = 4,
	Lowest = 5
}

export const ItemPriorityName = new Map<number, string>([
[ItemPriority.Highest,'Highest'],
[ItemPriority.AboveNormal,'Above normal'],
[ItemPriority.Normal,'Normal'],
[ItemPriority.BelowNormal,'Below normal'],
[ItemPriority.Lowest,'Lowest']]);

export enum AllowedSharePointObjectTypes {
	ListItem = 1,
	List = 2,
	Web = 4
}

export const AllowedSharePointObjectTypesName = new Map<number, string>([
[AllowedSharePointObjectTypes.ListItem,'ListItem'],
[AllowedSharePointObjectTypes.List,'List'],
[AllowedSharePointObjectTypes.Web,'Web']]);

export enum AutomaticSharePointUserCreationMode {
	Disabled = 0,
	All = 1,
	OnDemand = 2
}

export const AutomaticSharePointUserCreationModeName = new Map<number, string>([
[AutomaticSharePointUserCreationMode.Disabled,'Disabled'],
[AutomaticSharePointUserCreationMode.All,'All'],
[AutomaticSharePointUserCreationMode.OnDemand,'On Demand']]);

export enum AutoStartMode {
	Disabled = 0,
	Enabled = 1,
	Automatic = 2
}

export const AutoStartModeName = new Map<number, string>([
[AutoStartMode.Disabled,'Disabled'],
[AutoStartMode.Enabled,'Enabled'],
[AutoStartMode.Automatic,'Automatic']]);

export enum CBConnectionType {
	WebServiceXmlStateless = 0,
	GrpcXml = 1
}

export const CBConnectionTypeName = new Map<number, string>([
[CBConnectionType.WebServiceXmlStateless,'WebServiceXmlStateless'],
[CBConnectionType.GrpcXml,'GrpcXml']]);

export enum DocumentLocationFilterOperator {
	Equals = 717640000,
	NotEquals = 717640001,
	ContainsData = 717640002,
	DoesNotContainData = 717640003,
	Like = 717640004,
	NotLike = 717640005
}

export const DocumentLocationFilterOperatorName = new Map<number, string>([
[DocumentLocationFilterOperator.Equals,'Equals'],
[DocumentLocationFilterOperator.NotEquals,'NotEquals'],
[DocumentLocationFilterOperator.ContainsData,'ContainsData'],
[DocumentLocationFilterOperator.DoesNotContainData,'DoesNotContainData'],
[DocumentLocationFilterOperator.Like,'Like'],
[DocumentLocationFilterOperator.NotLike,'NotLike']]);

export enum FilterType {
	Global = 0,
	Entity = 1,
	SharePointFolder = 2
}

export const FilterTypeName = new Map<number, string>([
[FilterType.Global,'Global'],
[FilterType.Entity,'Entity'],
[FilterType.SharePointFolder,'SharePoint Folder']]);

export enum GroupStorage {
	SharePoint = 0,
	ActiveDirectory = 1,
	Office365 = 2,
	AzureActiveDirectory = 3
}

export const GroupStorageName = new Map<number, string>([
[GroupStorage.SharePoint,'SharePoint'],
[GroupStorage.ActiveDirectory,'ActiveDirectory'],
[GroupStorage.Office365,'Office365'],
[GroupStorage.AzureActiveDirectory,'AzureActiveDirectory']]);

export enum HighAvailabilityModes {
	None = 0,
	FailoverMain = 1,
	FailoverBackup = 2
}

export const HighAvailabilityModesName = new Map<number, string>([
[HighAvailabilityModes.None,'None'],
[HighAvailabilityModes.FailoverMain,'[Failover main]'],
[HighAvailabilityModes.FailoverBackup,'[Failover backup]']]);

export enum HighAvailabilityRuntimeStates {
	None = 0,
	MainRunning = 1,
	BackupWithSharedDatabaseRunning = 2,
	BackupWithIndependentDatabaseRunning = 3
}

export const HighAvailabilityRuntimeStatesName = new Map<number, string>([
[HighAvailabilityRuntimeStates.None,'None'],
[HighAvailabilityRuntimeStates.MainRunning,'MainRunning'],
[HighAvailabilityRuntimeStates.BackupWithSharedDatabaseRunning,'BackupWithSharedDatabaseRunning'],
[HighAvailabilityRuntimeStates.BackupWithIndependentDatabaseRunning,'BackupWithIndependentDatabaseRunning']]);

export enum LoginMatchRule {
	StartsWith = 0,
	EndsWith = 1,
	Contains = 2,
	UserNameMatch = 3
}

export const LoginMatchRuleName = new Map<number, string>([
[LoginMatchRule.StartsWith,'StartsWith'],
[LoginMatchRule.EndsWith,'EndsWith'],
[LoginMatchRule.Contains,'Contains'],
[LoginMatchRule.UserNameMatch,'UserNameMatch']]);

export enum MappingMode {
	APPEND = 0,
	REPLACE = 1
}

export const MappingModeName = new Map<number, string>([
[MappingMode.APPEND,'APPEND'],
[MappingMode.REPLACE,'REPLACE']]);

export enum MultipleLinkResolutionType {
	None = 1,
	OldestWins = 2,
	NewestWins = 3,
	And = 4,
	Or = 5
}

export const MultipleLinkResolutionTypeName = new Map<number, string>([
[MultipleLinkResolutionType.None,'None'],
[MultipleLinkResolutionType.OldestWins,'Oldest Wins'],
[MultipleLinkResolutionType.NewestWins,'Newest Wins'],
[MultipleLinkResolutionType.And,'Logical And'],
[MultipleLinkResolutionType.Or,'Logical Or']]);

export enum PollingForDocumentLocationMode {
	Automatic = 1,
	Always = 2,
	Never = 3
}

export const PollingForDocumentLocationModeName = new Map<number, string>([
[PollingForDocumentLocationMode.Automatic,'Automatic'],
[PollingForDocumentLocationMode.Always,'Always'],
[PollingForDocumentLocationMode.Never,'Never']]);

export enum PollingForRoleChangesMode {
	Always = 2,
	Never = 3
}

export const PollingForRoleChangesModeName = new Map<number, string>([
[PollingForRoleChangesMode.Always,'Always'],
[PollingForRoleChangesMode.Never,'Never']]);

export enum PrincipalType {
	SharePointUser = 0,
	SharePointGroup = 1,
	DirectoryGroup = 2,
	CRMUser = 3,
	CRMTeam = 4
}

export const PrincipalTypeName = new Map<number, string>([
[PrincipalType.SharePointUser,'SharePoint User'],
[PrincipalType.SharePointGroup,'SharePoint Group'],
[PrincipalType.DirectoryGroup,'Directory Group'],
[PrincipalType.CRMUser,'CRM User'],
[PrincipalType.CRMTeam,'CRM Team']]);

export enum ResetRoleInheritanceMode {
	Disabled = 0,
	Enabled = 1,
	Automatic = 2
}

export const ResetRoleInheritanceModeName = new Map<number, string>([
[ResetRoleInheritanceMode.Disabled,'Disabled'],
[ResetRoleInheritanceMode.Enabled,'Enabled'],
[ResetRoleInheritanceMode.Automatic,'Automatic']]);

export enum RoleFilterMode {
	NONE = 0,
	INCLUDE = 1,
	EXCLUDE = 2
}

export const RoleFilterModeName = new Map<number, string>([
[RoleFilterMode.NONE,'NONE'],
[RoleFilterMode.INCLUDE,'INCLUDE'],
[RoleFilterMode.EXCLUDE,'EXCLUDE']]);

export enum SdkMessageProcessingStepsRegistrationMode {
	UnmanagedCustomizations = 0,
	ManagedSolution = 1
}

export const SdkMessageProcessingStepsRegistrationModeName = new Map<number, string>([
[SdkMessageProcessingStepsRegistrationMode.UnmanagedCustomizations,'Unmanaged Customizations'],
[SdkMessageProcessingStepsRegistrationMode.ManagedSolution,'Managed Solution']]);

export enum SmtpType {
	BasicAuthentication = 0,
	MicrosoftAuthentication = 1,
	GoogleAuthentication = 2
}

export const SmtpTypeName = new Map<number, string>([
[SmtpType.BasicAuthentication,'BasicAuthentication'],
[SmtpType.MicrosoftAuthentication,'MicrosoftAuthentication'],
[SmtpType.GoogleAuthentication,'GoogleAuthentication']]);

export enum TargetSystemAuthenticationType {
	Password = 0,
	Adfs = 1,
	Modern = 2,
	Modern_AuthCodeFlow = 3,
	ModernManagedIdentity = 4
}

export const TargetSystemAuthenticationTypeName = new Map<number, string>([
[TargetSystemAuthenticationType.Password,'Password'],
[TargetSystemAuthenticationType.Adfs,'Adfs'],
[TargetSystemAuthenticationType.Modern,'Modern - Client credenatials'],
[TargetSystemAuthenticationType.Modern_AuthCodeFlow,'Modern - Authorization code'],
[TargetSystemAuthenticationType.ModernManagedIdentity,'Modern - Managed identity']]);

export enum UserMappingOperation {
	Add = 0,
	Block = 1
}

export const UserMappingOperationName = new Map<number, string>([
[UserMappingOperation.Add,'Add'],
[UserMappingOperation.Block,'Block']]);

export enum UserMappingStatus {
	Mapped = 0,
	NotMapped = 1,
	Blocked = 2,
	NoLicense = 3
}

export const UserMappingStatusName = new Map<number, string>([
[UserMappingStatus.Mapped,'Mapped'],
[UserMappingStatus.NotMapped,'NotMapped'],
[UserMappingStatus.Blocked,'Blocked'],
[UserMappingStatus.NoLicense,'NoLicense']]);

export enum WriterType {
	EMBEDDED = 0,
	DELEGATED = 1
}

export const WriterTypeName = new Map<number, string>([
[WriterType.EMBEDDED,'EMBEDDED'],
[WriterType.DELEGATED,'DELEGATED']]);

export enum AccessRights {
	None = 0,
	ReadAccess = 1,
	WriteAccess = 2,
	AppendAccess = 4,
	AppendToAccess = 16,
	CreateAccess = 32,
	DeleteAccess = 65536,
	ShareAccess = 262144,
	AssignAccess = 524288
}

export const AccessRightsName = new Map<number, string>([
[AccessRights.None,'None'],
[AccessRights.ReadAccess,'ReadAccess'],
[AccessRights.WriteAccess,'WriteAccess'],
[AccessRights.AppendAccess,'AppendAccess'],
[AccessRights.AppendToAccess,'AppendToAccess'],
[AccessRights.CreateAccess,'CreateAccess'],
[AccessRights.DeleteAccess,'DeleteAccess'],
[AccessRights.ShareAccess,'ShareAccess'],
[AccessRights.AssignAccess,'AssignAccess']]);

export enum PrivilegeDepth {
	Basic = 1,
	Local = 2,
	Deep = 4,
	Global = 8
}

export const PrivilegeDepthName = new Map<number, string>([
[PrivilegeDepth.Basic,'Basic'],
[PrivilegeDepth.Local,'Local'],
[PrivilegeDepth.Deep,'Deep'],
[PrivilegeDepth.Global,'Global']]);

export enum FolderNamingRule {
	Pattern = 1,
	CustomScript = 2
}

export const FolderNamingRuleName = new Map<number, string>([
[FolderNamingRule.Pattern,'Pattern'],
[FolderNamingRule.CustomScript,'Custom script']]);

export enum LibraryRule {
	None = 0,
	Period = 1,
	PerRecord = 2,
	StartingNameChars = 3,
	StartingIdChars = 4,
	CustomScript = 5
}

export const LibraryRuleName = new Map<number, string>([
[LibraryRule.None,'None'],
[LibraryRule.Period,'Period'],
[LibraryRule.PerRecord,'Per record'],
[LibraryRule.StartingNameChars,'Starting name characters'],
[LibraryRule.StartingIdChars,'Starting Id characters'],
[LibraryRule.CustomScript,'Custom script']]);

export enum Period {
	DayAndMonth = 1,
	Day = 2,
	Week = 3,
	Month = 4,
	Quarter = 5,
	Year = 6,
	Custom = 10
}

export const PeriodName = new Map<number, string>([
[Period.DayAndMonth,'Day and month'],
[Period.Day,'Day'],
[Period.Week,'Week'],
[Period.Month,'Month'],
[Period.Quarter,'Quarter'],
[Period.Year,'Year'],
[Period.Custom,'Custom']]);

export enum PeriodSource {
	UtcNow = 1,
	CreatedOn = 2
}

export const PeriodSourceName = new Map<number, string>([
[PeriodSource.UtcNow,'UTC Now (current date and time)'],
[PeriodSource.CreatedOn,'Created on (of CRM record)']]);

export enum ServiceStatusEnum {
	On = 0,
	OnNoLicense = 1,
	OnExpiredLicense = 2,
	OnBroken = 3,
	OnDifferentConfiguration = 4,
	Off = 5,
	OffNoLicense = 6,
	OffExpiredLicense = 7
}

export const ServiceStatusEnumName = new Map<number, string>([
[ServiceStatusEnum.On,'Active'],
[ServiceStatusEnum.OnNoLicense,'Active - no license'],
[ServiceStatusEnum.OnExpiredLicense,'Active - expired license'],
[ServiceStatusEnum.OnBroken,'Active - broken (contact support)'],
[ServiceStatusEnum.OnDifferentConfiguration,'Active - different configuration'],
[ServiceStatusEnum.Off,'Inactive'],
[ServiceStatusEnum.OffNoLicense,'Inactive - no license'],
[ServiceStatusEnum.OffExpiredLicense,'Inactive - expired license']]);

export enum SiteCollectionRule {
	None = 0,
	Period = 1,
	PerEntity = 2,
	CustomScript = 3
}

export const SiteCollectionRuleName = new Map<number, string>([
[SiteCollectionRule.None,'None'],
[SiteCollectionRule.Period,'Period'],
[SiteCollectionRule.PerEntity,'Per entity'],
[SiteCollectionRule.CustomScript,'Custom script']]);

export enum SiteRule {
	None = 0,
	Period = 1,
	PerEntity = 2,
	PerRecord = 3,
	StartingNameChars = 4,
	StartingIdChars = 5,
	CustomScript = 6
}

export const SiteRuleName = new Map<number, string>([
[SiteRule.None,'None'],
[SiteRule.Period,'Period'],
[SiteRule.PerEntity,'Per entity'],
[SiteRule.PerRecord,'Per record'],
[SiteRule.StartingNameChars,'Starting name characters'],
[SiteRule.StartingIdChars,'Starting Id characters'],
[SiteRule.CustomScript,'Custom script']]);

export enum SubfolderNameSource {
	LogicalName = 0,
	DisplayName = 1
}

export const SubfolderNameSourceName = new Map<number, string>([
[SubfolderNameSource.LogicalName,'Logical Name'],
[SubfolderNameSource.DisplayName,'Display Name']]);

